'use client';

import { useCallback, useState } from 'react';
import { toast } from 'sonner';

import { getDocumentSignedUrlAction } from '../server/actions';
import type { Document, DocumentWithUrl } from '../types';
import { downloadFile } from '../utils/download-utils';

export function useDocumentDownload() {
  const [isDownloading, setIsDownloading] = useState(false);

  const download = useCallback(
    async (document: Document | DocumentWithUrl): Promise<void> => {
      setIsDownloading(true);

      try {
        let url: string;

        if ('signedUrl' in document && document.signedUrl) {
          url = document.signedUrl;
        } else {
          const result = await getDocumentSignedUrlAction({
            bucket: document.bucket,
            path: document.storagePath,
            download: true,
          });

          if (!result.success) {
            throw new Error(result.error || 'Failed to get download URL');
          }
          url = result.url;
        }

        await downloadFile(url, document.fileName);
        toast.success('Document downloaded');
      } catch (error) {
        console.error('Download failed:', error);
        toast.error('Failed to download document');
      } finally {
        setIsDownloading(false);
      }
    },
    [],
  );

  return { download, isDownloading };
}
